export default {"src":"/_next/static/image/public/images/flags/flag_252.d71d6edac64a3048ae064b6fdec59905.svg","height":16,"width":24};